module.exports = __webpack_public_path__ + "static/media/img_qudao3@2x.b86b3661.png";